document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll("ul.slider[data-enable-drag='true'], ul.slider--desktop[data-enable-drag='true']");

  sliders.forEach((slider) => {
    let isDown = false;
    let startX;
    let scrollLeft;
    let isDragging = false;
    let lastX = 0;
    let velocity = 0;
    let frame;
    let animating = false;

    const cancelClick = (e) => {
      if (isDragging) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    };
    slider.querySelectorAll("a, button").forEach((el) => el.addEventListener("click", cancelClick, true));

    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    const smoothSnap = () => {
      if (animating) return;
      const slideWidth = slider.querySelector("li")?.offsetWidth || 0;
      if (!slideWidth) return;
      animating = true;
      const start = slider.scrollLeft;
      const targetIndex = Math.round(start / slideWidth);
      const target = targetIndex * slideWidth;
      const distance = target - start;
      const duration = 400;
      let startTime = null;
      const animate = (time) => {
        if (!startTime) startTime = time;
        const progress = Math.min((time - startTime) / duration, 1);
        const eased = easeOutCubic(progress);
        slider.scrollLeft = start + distance * eased;
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          animating = false;
        }
      };
      requestAnimationFrame(animate);
    };

    const momentum = () => {
      slider.scrollLeft -= velocity;
      velocity *= 0.9;
      if (Math.abs(velocity) > 0.5) {
        frame = requestAnimationFrame(momentum);
      } else {
        smoothSnap();
      }
    };

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      isDragging = false;
      slider.classList.add("is-dragging");
      startX = e.pageX;
      scrollLeft = slider.scrollLeft;
      lastX = e.pageX;
      velocity = 0;
      cancelAnimationFrame(frame);
    });

    slider.addEventListener("mouseleave", () => {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove("is-dragging");
      requestAnimationFrame(momentum);
    });

    slider.addEventListener("mouseup", () => {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove("is-dragging");
      velocity = Math.max(Math.min(velocity, 40), -40);
      requestAnimationFrame(momentum);
      setTimeout(() => (isDragging = false), 50);
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX;
      const walk = (x - startX) * 1.2;
      slider.scrollLeft = scrollLeft - walk;
      velocity = (x - lastX) * 0.8;
      lastX = x;
      if (Math.abs(x - startX) > 5) isDragging = true;
    });
  });
});
